import { jsx as _jsx } from "react/jsx-runtime";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { Presence } from "@radix-ui/react-presence";
import { Primitive } from "@radix-ui/react-primitive";
import { forwardRef, memo } from "react";
import { PANEL_CONTENT_NAME, usePanelContext } from "~/components/v2/components/shared/panel/PanelProvider";
import { getPanelState } from "~/components/v2/components/shared/panel/utils/getPanelState";
export const PanelContent = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { __scopePanel, className, forceMount, ...restOfProps } = param;
    const context = usePanelContext(PANEL_CONTENT_NAME, __scopePanel);
    const composedRefs = useComposedRefs(forwardedRef, context.contentRef);
    return /*#__PURE__*/ _jsx(Presence, {
        present: forceMount || context.open,
        children: /*#__PURE__*/ _jsx(Primitive.div, {
            className: className,
            "data-state": getPanelState(context.open),
            ...restOfProps,
            ref: composedRefs
        })
    });
}));
PanelContent.displayName = "PanelContent";
